/* eslint-disable no-console */
<template>
    <div>
      <div class="header_unit header_bg_white">
        <div class="header_box">
          <div class="menu_left">
            <router-link class="icn_back_black" :to="{ name: 'managemenu' , params: {brandPath: this.$route.params.brandPath}} "><p class="top_tit">＜戻る</p></router-link>
          </div>
          <div class="menu_center">
            <p class="menu_center_tex_l top_tit">ダッシュボード エリア設定</p>
          </div>
        </div>
      </div>
      <div class="main_unit menu_center">
        <div class="top_unit">
          <div class="top_name_box">企業管理者</div>
          <div class="top_center_box"> </div>
        </div>

        <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        <div v-if="apivalidationMessage" class="mgt_20 mgb_20 mgl_20">
          <Message :validationMessage="apivalidationMessage" />
        </div>
        <div style="display: flex;flex-wrap: nowrap; justify-content: center" v-show="!isLoading">

          <div v-show="showContent" class="area_setting_List_tbl_unit tbl_bg_blue mgt_15">
            <div style="display: flex;align-items: center;justify-content: space-between; padding:20px;">
              <h1>エリアリスト</h1>
              <div class="btn_submit letter_spa" style="margin: 0;">
                <a href="#" @click.prevent.stop="checkAreaFrom">エリア登録</a>
              </div>
            </div>
            <div  style="padding: 20px" id="areaSetting" name="areaSetting" >
              <table >
                <thead>
                <tr>
                  <th class="wd80 checkSetting_text_align">表示順</th>
                  <th class="wd350 checkSetting_text_align">エリア名</th>
                  <th class="checkSetting_text_align" style="min-width: 87px">店舗<br>リスト</th>
                  <th class="checkSetting_text_align" style="min-width: 87px">登録</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="area in areaList" :key=area.areaNo>
                  <td class="wd80 checkSetting_text_align" :class="{'is_active': isActive(area.id, selectedAreaId)}">{{area.areaNo}}</td>
                  <td class="wd350 view_setting_text_td" :class="{'is_active': isActive(area.id, selectedAreaId)}">
                    <input type="text" class="view_setting_text_input w-100 h-100" v-model="area.areaName" maxlength="30">
                  </td>
                  <td class="alertList_text_align dashboard_staff_kanri_box" :class="{'is_active': isActive(area.id, selectedAreaId)}">
                    <a href="#" @click.prevent.stop="getAreaStoreList(area.id)">リスト</a>
                  </td>
                  <td class="alertList_text_align dashboard_staff_kanri_box" :class="{'is_active': isActive(area.id, selectedAreaId)}">
                    <a href="#" @click.prevent.stop="getNoneAreaStoreList(area.id)">追加</a>
                  </td>
                </tr>
                </tbody>
              </table>
              <p id="checkSetting_err" class="lavel_error_font ">{{validation.areaSettingResult}}</p>
            </div>
          </div>
          <div v-show="showContent2" class="area_setting_stores_tbl_unit tbl_bg_blue mgt_15">
            <pulse-loader class="w-100 text-center" :loading="isLoading2"></pulse-loader>
            <div style="display: flex;align-items: center;justify-content: space-between; padding: 20px;">
            <h1>店舗リスト</h1>
            <div class="btn_submit letter_spa" style="margin: 0;">
              <a href="#"  @click.prevent.stop="checkAreaStoreSettingFrom">店舗登録</a>
            </div>
            </div>
            <div v-if="storeValidationMessage">
              <Message :validationMessage="storeValidationMessage" />
            </div>
            <div  style="padding: 20px" id="areaSetting" name="areaSetting" >
              <table>
                <thead>
                <tr>
                  <th class="wd100_fix_min checkSetting_text_align border_bottom_none">登録有無</th>
                  <th class="wd265 checkSetting_text_align" rowspan="2">店舗名</th>
                  <th class="wd400 checkSetting_text_align" rowspan="2">店舗住所</th>
                </tr>
                <tr>
                  <th class="wd100_fix_min border_top_none alertList_text_align">一括
                    <input type="checkbox" name="checkbox02" id="01-A" v-model="selectAll" @change="selectAllStore">
                    <label for="01-A" class="checkbox02"></label>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="store in storeList" :key=store.id>
                  <td class="wd100 alertList_text_align text_white_space">
                    <input type="checkbox" name="checkbox02" :id="store.id" v-model="selectedStoreIds" :value="store.id" @click="selectItemClick()">
                    <label class="checkbox02" :for="store.id"></label>
                  </td>
                  <td class="wd265" style="max-width: 265px;white-space: pre-wrap;">{{store.storeName}}</td>
                  <td class="wd400" style="max-width: 265px;white-space: pre-wrap;">{{store.address}}</td>
                </tr>
                </tbody>
              </table>
              <p id="checkSetting_err" class="lavel_error_font ">{{validation.checkSettingResult}}</p>

            </div>
          </div>
        </div>
      </div>
      <div class="overlay" v-show="showContent3">
        <div>
          <div class="modal_box wd512">
            <div class="modal_header_unit">
              <div class="modal_header_box">
                <p class="modal_header_tit_s"></p>
                <p class="modal_header_tit">エリア登録</p>
              </div>
            </div>
            <div class="modal_content_tex">
              <p>エリアの登録が完了しました。</p>
            </div>
            <div class="btn_submit_box">
              <div class="btn_submit2">
                <a role="button" @click.prevent.stop="closeModal()">閉じる</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overlay" v-show="showContent4">
        <div>
          <div class="modal_box wd512">
            <div class="modal_header_unit">
              <div class="modal_header_box">
                <p class="modal_header_tit_s"></p>
                <p class="modal_header_tit">店舗登録</p>
              </div>
            </div>
            <div class="modal_content_tex">
              <p>店舗登録が完了しました。</p>
            </div>
            <div class="btn_submit_box">
              <div class="btn_submit2">
                <a role="button" @click.prevent.stop="closeModal2()">閉じる</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import PulseLoader from '@/app/components/PulseLoader.vue'
import Message from '@/app/components/Message.vue'

export default {
  name: "DashboardAreaSetting",
  components: {
    PulseLoader,
    Message,
  },
  created() {
    // 年月セット
    this.calc()
  },
  data: function () {
    return {
      showContent: false,
      showContent2: false,
      showContent3: false,
      showContent4: false,
      isLoading: false,
      isLoading2: false,
      isInitLoading: false,
      apiValidationMessage: "",
      areaValidationMessage: "",
      storeValidationMessage: "",
      addFormFlg: true,
      areaList:[],
      area:[],
      storeList:[],
      storeAreaIds:[],
      selectedIndex: 0,
      selectAll:false,
      selectedStore:[],
      selectedStoreIds: [],
      selectedAreaId:0,
      validation:{
        areaSettingResult:"",
        storeSettingResult:"",
      },
    }
  },
  computed: {
    brandPath: function () {
      return this.$store.getters['brand/path']
    },
  },
  methods: {
    async calc() {
      this.isLoading = true;
      let brandId = this.$store.getters['brand/id'];
      this.apivalidationMessage = "";

      //取得API呼び出し
      await this.$axios
          .get(this.$apiEndpoint + 'manage/brand/' + brandId + '/dashboard/areaSetting')
          .then(response => {
            this.areaList = response['data']['area'];
            this.showContent = true;
            this.showContent2 = true;
          })
          .catch((err) => {
            let error = {
              button: {
                path: {name: 'top', params:{brandPath: this.brandPath}}
              }}
            if (err.customError) {
              error = Object.assign(error, err.customError);

              if(error.code == 400){
                this.apivalidationMessage =  error.message;
              }
              if(error.code !== 400){
                this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
              }
            }
          }).finally(()=> this.isLoading = false);
    },
    checkAreaFrom: function() {
      this.addFormFlg = true;
      this.isLoading = true;
      this.apivalidationMessage = '';
      const inputArea = this.areaList.filter(item => item.areaName !== undefined && item.areaName !== null && item.areaName !== '');
      if(inputArea.length > 0) {
        this.updateArea(this.areaList);
      } else {
        this.isLoading = false;
        this.addFormFlg = false;
        this.apivalidationMessage = 'エリア名は必須項目です';
      }
    },
    updateArea: async function(inputArea) {
      if(this.addFormFlg) {
        const brandId = this.$store.getters['brand/id']
        // request作成
        var requestBody = {}
        requestBody.area_list = inputArea;
        var formRequestBody = this.jsonToFormData(requestBody);

        var config = {
          headers: {
            'Content-Type': 'multipart/form-data;'
          }
        }
        await this.$axios
            .post(this.$apiEndpoint + 'manage/brand/' + brandId + '/dashboard/areaSetting/updateArea', formRequestBody, config)
            .then(() => {
              this.showContent = true;
              this.addFormFlg = false;
            })
            .catch((err) => {
              let error = {
                button: {
                  path: {name: 'top', params: {brandPath: this.brandPath}}
                }
              }
              if (err.customError) {
                error = Object.assign(error, err.customError);

                if(error.code == 400){
                  this.apivalidationMessage =  error.message;
                }
                if(error.code !== 400){
                  this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }
              }
            }).finally(() => this.isLoading = false);
      }
    },
    selectItemClick() {
      if(this.selectAll) {
        this.selectAll = false;
      }
    },
    selectAllStore() {
      if(this.selectAll) {
        this.selectedStoreIds = this.storeList.map((item) => item.id);
      } else {
        this.selectedStoreIds = [];
      }
    },
    closeModal() {
      this.calc()
      this.showContent3 = false;
    },
    closeModal2() {
      this.showContent4 = false;
    },
    buildFormData(formData, data, parentKey) {
      if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
          this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
      } else {
        const value = data == null ? '' : data;

        formData.append(parentKey, value);
      }
    },
    jsonToFormData(data) {
      const formData = new FormData();

      this.buildFormData(formData, data);

      return formData;
    },
    getAreaStoreList: function(areaId) {
      this.selectedStoreIds = [];
      this.selectItemClick();
      this.selectedAreaId = areaId;
      this.getStoreList(this.selectedAreaId)
    },
    getNoneAreaStoreList: function(areaId) {
      this.selectedStoreIds = [];
      this.selectItemClick();
      this.selectedAreaId = areaId;
      this.getStoreList(0)
    },
    getStoreList: async function(areaId) {
      this.isLoading2 = true;
      this.apivalidationMessage = '';
      this.storeList = [];
      const brandId = this.$store.getters['brand/id']
      //取得API呼び出し
      var params = {
        'area_id':areaId
      }
      await this.$axios
          .get(this.$apiEndpoint + 'manage/brand/' + brandId + '/dashboard/areaSetting/storeList', {params})
          .then(response => {
            this.storeList = response['data']['stores'];
            this.isLoading2 = false;
          })
          .catch((err) => {
            let error = {
              button: {
                path: {name: 'top', params:{brandPath: this.brandPath}}
              }}
            if (err.customError) {
              error = Object.assign(error, err.customError);

              if(error.code == 400){
                this.apivalidationMessage =  error.message;
              }
              if(error.code !== 400){
                this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
              }
            }
          }).finally(()=> this.isLoading = false);
    },
    checkAreaStoreSettingFrom: function() {
      this.addFormFlg = true;
      this.isLoading = true;
      this.apivalidationMessage = '';
      const areaNameList = this.areaList.filter(item => item.id == this.selectedAreaId).map(item => item.areaName);
      if(this.selectedAreaId == 0) {
        this.isLoading = false;
        this.addFormFlg = false;
        this.apivalidationMessage = '登録するエリアを選択してください';
      } else if(this.storeList.length <= 0){
        this.isLoading = false;
        this.addFormFlg = false;
        this.apivalidationMessage = '登録する店舗を選択してください';
      } else if((areaNameList[0] === undefined || areaNameList[0] === null || areaNameList[0] === '') && this.selectedStoreIds.length > 0){
        //エリア名未記入且つ登録しようとしている店舗がある場合
        this.isLoading = false;
        this.addFormFlg = false;
        this.apivalidationMessage = 'エリア名が入力されていません';
      } else {
        const areaCancellationStore = this.storeList.filter(item => !this.selectedStoreIds.includes(item.id)).map(item => item.id);
        this.updateStoreAreaSetting(this.selectedStoreIds, areaCancellationStore);
      }
    },
    updateStoreAreaSetting: async function(inputRegisterStores, areaCancellationStore) {
      if(this.addFormFlg) {
        const brandId = this.$store.getters['brand/id']
        // request作成
        var requestBody = {}
        requestBody.area_id = this.selectedAreaId;
        requestBody.register_store_ids = inputRegisterStores;
        requestBody.area_cancellation_store_ids = areaCancellationStore;
        var formRequestBody = this.jsonToFormData(requestBody);

        var config = {
          headers: {
            'Content-Type': 'multipart/form-data;'
          }
        }
        await this.$axios
            .post(this.$apiEndpoint + 'manage/brand/' + brandId + '/dashboard/areaSetting/updateStoreAreaSetting', formRequestBody, config)
            .then(() => {
              this.showContent4 = true;
              this.addFormFlg = false;
              this.selectedStoreIds = [];
            })
            .catch((err) => {
              let error = {
                button: {
                  path: {name: 'top', params: {brandPath: this.brandPath}}
                }
              }
              if (err.customError) {
                error = Object.assign(error, err.customError);

                if(error.code == 400){
                  this.apivalidationMessage =  error.message;
                }
                if(error.code !== 400){
                  this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }
              }
            }).finally(() => this.isLoading = false);
      }
    },
    isActive: function (row, selectedIndex) {
      return row == selectedIndex
    },
  }
}
</script>